import React from 'react';
import { Link } from 'react-router-dom';
import './MenuBar.css'
import { ArrowDropDown, ArrowRight, Circle } from '@mui/icons-material';
import { Icon } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setMenuOpen, setMenuSelected, setTitle } from 'redux/slices/uiSlice';
import theme from 'config/theme';

const MenuBar = ({ id, parentId, name, icon, page, list, children, hover }) => {
  const dispatch = useDispatch();
  const { menuOpen, menuSelected } = useSelector((state) => state.ui);
  const { rol } = useSelector((store) => store.session);
  const open = menuOpen?.includes(id);

  const handlerNavigate = () => {
    dispatch(setMenuSelected(id));
    if (list)
      dispatch(setMenuOpen(open ? null : [id, parentId].filter(Boolean)));
    if (page) {
      dispatch(setTitle(name));
    }
  }
  const shouldHighlight = ['Punto de Venta', 'Menudeo'].includes(rol?.name) && name === 'Venta';
  return (
    <>
      <Link to={page} >
        <div className='container-wrap-menu-bar'
          onClick={handlerNavigate}
        >
          <div className={`container-menu-bar ${open ? 'open' : ''} ${shouldHighlight ? 'highlight-border' : ''}`}>
            {
              icon && (
                !list && menuSelected === id ?
                  <Icon className={`menu-bar-icon`}>
                    <Circle htmlColor={theme.contrastColor} sx={{ width: 10, height: 10 }} />
                  </Icon>:
                  (icon.includes && icon.includes('data:image')) ?
                    <img alt='icon' src={icon} className={`menu-bar-icon ${open ? 'dark_image' : 'light_image'}`} /> :
                    <Icon className={`menu-bar-icon`}>{icon}</Icon>
              )
            }
            <div className='container-menu-bar-name' title={hover}>
              <span className='menu-bar-name'>{name}</span>
            </div>
            <div className='container-menu-bar-icon-arrow'>
              {
                list && (open ? <ArrowDropDown className='menu-bar-icon-arrow' /> : <ArrowRight className='menu-bar-icon-arrow' />)
              }
            </div>
          </div>
        </div>
        {
          open && children
        }
      </Link>
    </>
  )
}

export default MenuBar;